import {useState} from 'react';
import {
  makeStyles,
  tokens,
  Button,
  Popover,
  PopoverSurface,
  PopoverTrigger,
  ToolbarButton
} from '@fluentui/react-components';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { loginRequest } from '../authConfig';

const useStyles = makeStyles({
  logoutButton: {
    backgroundColor: tokens.colorNeutralForeground3,
    ':hover': {
      backgroundColor: tokens.colorNeutralForeground3Hover,
    }
  }
});

const SignInButton = () => {
  const {instance} = useMsal();

  const handleLogin = () => {
    instance.loginRedirect(loginRequest).catch(e => {
      console.error(e);
    });
  };

  return (
    <Button appearance="primary" onClick={handleLogin}>Se connecter</Button>
  );
};

const SignOutButton = () => {
  const { instance, accounts } = useMsal();
  const [isOpen, setIsOpen] = useState(false);
  const styles = useStyles();

  const username = accounts.length > 0 ? accounts[0].username : '';

  const handleLogout = () => {
    setIsOpen(false);
    instance.logoutRedirect({
      postLogoutRedirectUri: "/"
    });
  };

  return (
    <Popover
      withArrow
      trapFocus
      open={isOpen}
      onOpenChange={(_, data) => setIsOpen(data.open ? true : false)}
    >
      <PopoverTrigger disableButtonEnhancement>
        <ToolbarButton>
          {username}
        </ToolbarButton>
      </PopoverTrigger>
      <PopoverSurface>
        <div>
          <Button
            className={styles.logoutButton}
            appearance="primary"
            onClick={handleLogout}>
            Se déconnecter
          </Button>
        </div>
      </PopoverSurface>
    </Popover>
  );
}

export default function AuthButton () {
  return useIsAuthenticated() ? <SignOutButton /> : <SignInButton />;
}
